module.exports = __webpack_public_path__ + "img/atm.52ec49a6.jpg";